import { AuthenticationResult, SilentRequest } from "@azure/msal-browser";
import { getMsalInstance } from "./msal-instance";

export const getAccessToken = async (): Promise<string> => {
    const msalInstance = getMsalInstance();
    const activeAccount = msalInstance.getActiveAccount();

    const apiClientId = window.sessionStorage.getItem('apiClientId') || '';
    if (apiClientId === '') throw new Error("Api identification is missing");

    const apiScope = `api://${apiClientId}/access_as_user`;

    try {

        if (!activeAccount) {
            throw new Error("No active account found.");
        }
        const request: SilentRequest = {
            scopes: [apiScope],
            account: activeAccount,
        };

        const response: AuthenticationResult = await msalInstance.acquireTokenSilent(request);

        //// Utile in debug - Estrae la data di scadenza dal token
        //const decodedToken = JSON.parse(atob(response.accessToken.split(".")[1]));
        //const expirationTimestamp = decodedToken.exp * 1000; // Converti in millisecondi
        //const expirationDate = new Date(expirationTimestamp).toLocaleString(); // Formatta in locale
        //console.log(`🕒 Token expires on: ${expirationDate}`);

        return response.accessToken;

    } catch (error) {
        console.warn("Silent token acquisition failed. Redirecting to login...");
        await msalInstance.loginRedirect({ scopes: [apiScope] });
        throw error;
    }
};
